export const defaultPage = 0
export const defaultStepsLimit = 50
export const defaultSort = 'name-asc'

export const stepsSortOptions = [
  {
    label: 'sort-name-asc.v',
    value: 'name-asc',
  },
  {
    label: 'sort-name-desc.v',
    value: 'name-desc',
  },
  {
    label: 'sort-created-desc.v',
    value: 'created_at-desc',
  },
  {
    label: 'sort-created-asc.v',
    value: 'created_at-asc',
  },
  {
    label: 'sort-updated-desc.v',
    value: 'updated_at-desc',
  },
  {
    label: 'sort-updated-asc.v',
    value: 'updated_at-asc',
  },
]
